import { Box } from '@mui/material';
import React from 'react';
import { DateRange } from './common';
import {
  fileTypes, minDate, report_type, reportTitles,
} from '../constants';
import { getWasteTypesRequest } from '../../../../api/wasteTypeApi';
import { AsyncAutocomplete } from '../../../../components/AutoCompletes/AsyncAutocomplete';
import { DEFAULT_AUTOCOMPLETE_FIELD } from '../../../../components/Inputs/CustomAutocomplete';
import { useGetReport } from '../utils';
import { createReportRequest } from '../../../../api/reportApi';
import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  date_from: null,
  date_to: null,
  fkko_code: '',
};

export function AnalysisWasteReport() {
  const getReports = async ({ form }) => {
    try {
      return createReportRequest({
        format_type: fileTypes.xlsx,
        report_type,
        kind: reportTitles.analysis_waste_fkko_codes,
        options: { ...form, fkto_id: Number(form.fkko_code.id) },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const {
    form,
    onChange,
    makeRequest,
    clear,
    dateError,
    isCleared,
    setIsCleared,
  } = useGetReport({
    initialForm,
    withDownload: true,
    getReports,
    withMinDate: true,
  });

  const {
    date_to,
    date_from,
    fkko_code,
  } = form;

  return (
    <ReportTemplate
      reportTitle="Период принятия отчета"
      visibleClear={date_from !== null || date_to !== null || fkko_code}
      clear={clear}
      downloadOptions={{ disableDownload: !date_from || !date_to || !fkko_code, makeRequest }}
      error={dateError}
    >
      {' '}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DateRange
          date_to={date_to}
          date_from={date_from}
          onChange={onChange}
          minDate={minDate}
          isCleared={isCleared}
          setIsCleared={setIsCleared}
        />
        <AsyncAutocomplete
          sx={{ minWidth: '250px' }}
          label="Код отхода"
          name="fkko_code"
          request={getWasteTypesRequest}
          optionField={{ ...DEFAULT_AUTOCOMPLETE_FIELD, label: 'code' }}
          value={fkko_code}
          onChange={onChange}
        />
      </Box>
    </ReportTemplate>
  );
}
